import { useEffect, useState } from 'react';
import Categories from '../Layouts/Categories';
import Banner from './Banner/Banner';
import ProductSlider from './ProductSlider/ProductSlider';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, getSliderProducts } from '../../actions/productAction';
import { getBanners } from '../../actions/bannerAction';
import { useSnackbar } from 'notistack';
import MetaData from '../Layouts/MetaData';
import CartSlider from './CartSlider/CartSlider';
import axios from 'axios';
import { getDiscount } from '../../utils/functions';

const Home = () => {

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { error, loading, products = [] } = useSelector((state) => state.products);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { cartItems } = useSelector((state) => state.cart);
  const { banners } = useSelector((state) => state.banners);

  const [recentlyViewedProducts, setRecentlyViewedProducts] = useState([]);
  const [recentlyViewedLoading, setRecentlyViewedLoading] = useState(false);

  const transformedWishlistItems = wishlistItems.map(item => ({
    _id: item.product,
    name: item.name,
    images: [{ lowUrl: item.image }],
    ratings: item.ratings,
    numOfReviews: item.reviews,
    price: item.price,
    mrp: item.cuttedPrice
  }));

  const productsOnOffer = (products || []).filter(p => p.mrp && p.price < p.mrp).sort((a, b) => getDiscount(b.price, b.mrp) - getDiscount(a.price, a.mrp)).slice(0, 10);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: "error" });
      dispatch(clearErrors());
    }
    dispatch(getSliderProducts());
    dispatch(getBanners());
  }, [dispatch, error, enqueueSnackbar]);

  useEffect(() => {
    const fetchRecentlyViewed = async () => {
      setRecentlyViewedLoading(true);
      const recentlyViewedIds = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      if (recentlyViewedIds.length > 0) {
        try {
          const requests = recentlyViewedIds.map(id => axios.get(`/api/v1/product/${id}`));
          const responses = await Promise.all(requests);
          setRecentlyViewedProducts(responses.map(res => res.data.product));
        } catch (error) {
          console.error("Failed to fetch recently viewed products:", error);
        }
      }
      setRecentlyViewedLoading(false);
    };

    fetchRecentlyViewed();
  }, []);

  return (
    <>
      <MetaData title={"Online Shopping Site for Mobiles, Electronics, Furniture, Grocery, Lifestyle, Books & More. Best Offers!"} />
      <Banner banners={banners} />
      <Categories />
      <main className="flex flex-col gap-3 px-2 mt-16 sm:mt-2">
        {!loading && <ProductSlider title={"Top Offers"} tagline={"Biggest Discounts"} products={productsOnOffer} />}
        <ProductSlider title={"My Wishlist"} tagline={"Based on Your Activity"} products={transformedWishlistItems} emptyMessage={"No items in your wishlist."} />
        <CartSlider title={"My Cart"} tagline={"Based on Your Activity"} products={cartItems} />
        {!loading && <ProductSlider title={"Suggested for You"} tagline={"Based on Your Activity"} products={[...products].sort(() => Math.random() - 0.5)} />}
        <ProductSlider title={"Recently Viewed"} tagline={"Based on Your Browsing History"} products={recentlyViewedProducts} loading={recentlyViewedLoading} emptyMessage={"No recently viewed items."} />
      </main>
    </>
  );
};

export default Home;
